// GA4/Ads Consent - don't load inside DOMContentLoaded. Must load before GA4.
window.dataLayer = window.dataLayer || [];
function gtag(){ dataLayer.push(arguments); }
gtag('consent', 'default', {
  'ad_storage': 'granted',
  'ad_user_data': 'granted',
  'ad_personalization': 'granted',
  'analytics_storage': 'granted',
  'functionality_storage': 'granted',
  'personalization_storage': 'granted',
  'security_storage': 'granted',
  'wait_for_update': 500
});
window.addEventListener('DOMContentLoaded', () => {
  gtag('consent', 'update', {
    'ad_storage': 'granted',
    'ad_user_data': 'granted',
    'ad_personalization': 'granted',
    'analytics_storage': 'granted',
    'functionality_storage': 'granted',
    'personalization_storage': 'granted',
    'security_storage': 'granted'
  });
});


// Attaches Matomo Visitor ID from Matomo's cookie. Adds it to the order using cart note attributes
window.addEventListener('DOMContentLoaded', async () => {
  // Matomo visitor IDs are 16 hex chars; the Tracking API rejects anything else as _id
  const cid = document.cookie.match(/(?:^|;\s*)_pk_id\.[^=]+=([a-f0-9]{16})\./i)?.[1];
  if (!cid) return;

  // Shopify.routes.root keeps requests on the right locale/market path (e.g. /en-ca/)
  const cartUrl = `${window.Shopify?.routes?.root || '/'}cart`;

  try {
    // Check the live cart rather than a session flag, so a new cart (e.g. after checkout) gets the ID too
    const cartRes = await fetch(`${cartUrl}.js`);
    if (!cartRes.ok) throw new Error(`cart.js HTTP ${cartRes.status}`);
    const cart = await cartRes.json();
    if (cart.attributes?.matomoCid === cid) return;

    const updateRes = await fetch(`${cartUrl}/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: `attributes[matomoCid]=${encodeURIComponent(cid)}`
    });
    if (!updateRes.ok) throw new Error(`update.js HTTP ${updateRes.status}`);
  } catch (e) {
    console.error('[persistMatomoCid]', e);
  }
});


// Main menu tracking
document.addEventListener('DOMContentLoaded', function() {
  if (typeof gtag !== 'function') return;

  const mainMenu = document.querySelector('.main-nav');
  if (!mainMenu) return;

  const getMenuItemText = (item) => (item.querySelector('.main-nav__item-content') || item).textContent.trim();

  mainMenu.addEventListener('click', function(event) {
    const menuItem = event.target.closest('a.main-nav__item');
    if (!menuItem) return;

    const breadcrumbParts = [];
    const clickedItemText = getMenuItemText(menuItem);
    if (clickedItemText) breadcrumbParts.push(clickedItemText);

    // Walk up nested <details>, prepending each parent's summary link. Stop at the menu boundary
    // so a wrapping <details> (e.g. the mobile hamburger) isn't added to the breadcrumb
    let currentDetails = menuItem.closest('details');
    while (currentDetails && mainMenu.contains(currentDetails)) {
      const summary = currentDetails.querySelector(':scope > summary');
      if (!summary) break;

      const summaryLink = summary.querySelector('a.main-nav__item');
      if (summaryLink && !summary.contains(menuItem)) {
        const summaryText = getMenuItemText(summaryLink);
        if (summaryText) breadcrumbParts.unshift(summaryText);
      }

      currentDetails = currentDetails.parentElement?.closest('details');
    }

    gtag('event', 'click', {
      event_category: 'Main Menu',
      event_label: breadcrumbParts.join(' > '),
      link_url: menuItem.href || 'No URL'
    });
  });
});


// Mobile menu hamburger open/close tracking. Link tracking comes from main menu tracking.
document.addEventListener('DOMContentLoaded', function() {
  if (typeof gtag !== 'function') return;

  const detailsElement = document.querySelector('.main-menu__toggle')?.closest('details');
  if (!detailsElement) return;

  detailsElement.addEventListener('toggle', function() {
    gtag('event', 'click', {
      event_category: 'Mobile Menu',
      event_label: detailsElement.open ? 'Opened Mobile Menu' : 'Closed Mobile Menu'
    });
  });
});


// Main Menu Sidebar
document.addEventListener('DOMContentLoaded', function() {
  if (typeof gtag !== 'function') return;

  const sidebar = document.querySelector('.sidebar-drawer');
  if (!sidebar) return;

  sidebar.addEventListener('click', function(event) {
    const link = event.target.closest('.menu-link, .all-btn');
    if (!link) return;

    let currentPanel = link.closest('.menu-panel');
    if (!currentPanel) return;

    // Build the hierarchy path by walking up the menu levels until we reach the root.
    // Track visited panels so a trigger inside its own panel can't loop forever
    const path = [link.textContent.trim()];
    const visited = new Set();

    while (currentPanel?.id && currentPanel.id !== 'menu-root' && !visited.has(currentPanel)) {
      visited.add(currentPanel);

      const trigger = document.querySelector(`[data-target="${CSS.escape(currentPanel.id)}"]`);
      if (!trigger) break;

      const parentLink = trigger.closest('.menu-link-row')?.querySelector('.menu-link');
      if (parentLink) path.unshift(parentLink.textContent.trim());

      // Move to the panel that contains the trigger to continue climbing
      currentPanel = trigger.closest('.menu-panel');
    }

    gtag('event', 'click', {
      event_category: 'Main Menu Sidebar',
      event_label: path.join(' > '),
      link_url: link.href
    });
  });
});


// Homepage slider tracking
document.addEventListener('DOMContentLoaded', function() {
  if (typeof gtag !== 'function') return;
  if (!document.documentElement.classList.contains('is-home')) return;

  const slides = document.querySelectorAll('.slideshow__slide');
  if (slides.length === 0) return;

  slides.forEach((slide, index) => {
    const link = slide.querySelector('a.btn--secondary');
    if (!link) return;

    link.addEventListener('click', function() {
      const title = slide.querySelector('.text-overlay__heading')?.textContent.trim() || 'Unknown Title';
      const position = slide.getAttribute('aria-label') || `${index + 1} of ${slides.length}`;

      gtag('event', 'click', {
        event_category: 'Homepage Slider',
        event_label: `${title} | Slide ${position}`,
        link_url: link.href
      });
    });
  });
});


// Homepage Gallery Banners
document.addEventListener('DOMContentLoaded', function() {
  if (typeof gtag !== 'function') return;
  if (!document.documentElement.classList.contains('is-home')) return;

  const galleries = document.querySelectorAll('.gallery');
  if (galleries.length === 0) return;

  galleries.forEach(gallery => {
    gallery.addEventListener('click', function(event) {
      const clickedLink = event.target.closest('a.gallery-block');
      if (!clickedLink) return;

      gtag('event', 'click', {
        event_category: 'Gallery Banner',
        event_label: clickedLink.querySelector('h3 p')?.textContent.trim() || 'No Title',
        link_url: clickedLink.href
      });
    });
  });
});


// Homepage home-grid-box
document.addEventListener('DOMContentLoaded', function() {
  if (typeof gtag !== 'function') return;
  if (!document.documentElement.classList.contains('is-home')) return;

  const gridBoxes = document.querySelectorAll('.home-grid-box');
  if (gridBoxes.length === 0) return;

  gridBoxes.forEach(gridBox => {
    gridBox.addEventListener('click', function(event) {
      const clickedLink = event.target.closest('a');
      if (!clickedLink) return;

      gtag('event', 'click', {
        event_category: 'Home Grid Box',
        event_label: clickedLink.querySelector('h5')?.textContent.trim() || 'No Title',
        link_url: clickedLink.href
      });
    });
  });
});


// Homepage Section Buttons
document.addEventListener('DOMContentLoaded', function() {
  if (typeof gtag !== 'function') return;
  if (!document.documentElement.classList.contains('is-home')) return;

  const sections = document.querySelectorAll('.shopify-section.cc-media-with-text');
  if (sections.length === 0) return;

  sections.forEach(section => {
    const button = section.querySelector('.section__block--button a');
    if (!button) return;

    button.addEventListener('click', function() {
      const heading = section.querySelector('h2.section__block--heading.h3')?.textContent.trim();

      gtag('event', 'click', {
        event_category: 'Homepage Section Button',
        event_label: `${heading ? `Title: ${heading} | ` : ''}Button: ${button.textContent.trim()}`,
        link_url: button.href
      });
    });
  });
});


// Homepage Hero
document.addEventListener('DOMContentLoaded', function() {
  if (typeof gtag !== 'function') return;
  if (!document.documentElement.classList.contains('is-home')) return;

  const heroes = document.querySelectorAll('.jonny-hero');
  if (heroes.length === 0) return;

  // Strip arrows, emoji, dingbats and icon-font glyphs (\p{Sm}, \p{So}, private use \p{Co}, plus
  // emoji joiner/variation chars and « » ‹ › used as arrows), then collapse leftover whitespace.
  // Letters, numbers and text punctuation like & ' % $ stay
  const cleanText = (text) => text.replace(/[\p{Sm}\p{So}\p{Co}\u200D\uFE0F«»‹›]/gu, '').replace(/\s+/g, ' ').trim();

  heroes.forEach(hero => {
    // Delegate so CTAs on every slide are tracked, not just the first slide's
    hero.addEventListener('click', function(event) {
      const link = event.target.closest('.jonny-hero-cta-row a');
      if (!link) return;

      const slide = link.closest('[data-hero-slide]');
      const heading = cleanText(slide?.querySelector('.jonny-hero-heading')?.textContent || '') || 'Unknown Slide';

      const slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      const slideIndex = slides.indexOf(slide);
      const position = slideIndex >= 0 ? ` | Slide ${slideIndex + 1} of ${slides.length}` : '';

      gtag('event', 'click', {
        event_category: 'Homepage Hero',
        event_label: `${heading} > ${cleanText(link.textContent) || 'No Link Text'}${position}`,
        link_url: link.href
      });
    });
  });
});


// Builder Steps
document.addEventListener('DOMContentLoaded', function() {
  if (typeof gtag !== 'function') return;

  if (!document.documentElement.classList.contains('is-builder')) return;

  const headingSelector = '.cd-steps__panels h2.cd-steps__label[data-step-target]';
  const trackedSteps = new Set();

  // Listeners are delegated from document: the builder renders seconds after load and may re-render
  // its panels, so nothing is looked up until a click actually happens.

  // Heading clicks. Bubble phase on purpose: the builder toggles 'closed' before this runs, so a
  // heading without 'closed' here means the user just opened that step; collapsing a step is skipped
  document.addEventListener('click', function(event) {
    const stepHeading = event.target.closest(headingSelector);
    if (!stepHeading || stepHeading.classList.contains('closed')) return;
    trackStep(stepHeading);
  });

  // Clicks inside a step's content, so steps that are open by default still get tracked.
  // Capture phase so the clicked element is checked before the builder can re-render it
  document.addEventListener('click', function(event) {
    if (event.target.closest(headingSelector)) return;

    // A heading's data-step-target (e.g. "#cd-step-fabric") points at its content element
    const stepHeading = Array.from(document.querySelectorAll(headingSelector)).find(heading => {
      const target = heading.dataset.stepTarget;
      return target.startsWith('#') && document.getElementById(target.slice(1))?.contains(event.target);
    });
    if (stepHeading) trackStep(stepHeading);
  }, true);

  function trackStep(stepHeading) {
    const targetValue = stepHeading.dataset.stepTarget || '';

    // One event per step per page load. Keyed on the step target so opening a step and then
    // clicking inside it count as the same step
    const stepId = targetValue || stepHeading.id || stepHeading.textContent.trim();
    if (trackedSteps.has(stepId)) return;
    trackedSteps.add(stepId);

    // e.g. "retractable-awning" -> "Builder: Retractable Awning"
    const builderType = stepHeading.closest('.cd-steps__panels').dataset.builderType;
    const builderName = builderType
      ? builderType.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
      : 'Unknown Builder';

    // Extract step name from data-step-target (e.g., "#cd-step-fabric" -> "Fabric")
    const stepName = targetValue.match(/#cd-step-(.+)/)?.[1];
    const stepText = stepName ? stepName.charAt(0).toUpperCase() + stepName.slice(1) : 'Unknown Step';

    gtag('event', 'click', {
      event_category: `Builder: ${builderName}`,
      event_label: `Clicked Step: ${stepText}`,
      link_url: window.location.href
    });
  }
});


// Footer Menus
document.addEventListener('DOMContentLoaded', function() {
  if (typeof gtag !== 'function') return;

  const menuSections = document.querySelectorAll('details.footer-menu.disclosure');
  if (menuSections.length === 0) return;

  menuSections.forEach(section => {
    section.addEventListener('click', function(event) {
      const clickedLink = event.target.closest('ul.footer-menu__links a');
      if (!clickedLink) return;

      const sectionTitle = this.querySelector('h2.disclosure__title')?.textContent.trim() || 'Unknown Section';

      gtag('event', 'click', {
        event_category: `Footer Menu ${sectionTitle} Grouping`,
        event_label: clickedLink.textContent.trim() || 'No Link Text',
        link_url: clickedLink.href
      });
    });
  });
});


// Sub Footer Menu
document.addEventListener('DOMContentLoaded', function() {
  if (typeof gtag !== 'function') return;

  const sublinksMenus = document.querySelectorAll('ul.footer-sublinks');
  if (sublinksMenus.length === 0) return;

  sublinksMenus.forEach(sublinksMenu => {
    sublinksMenu.addEventListener('click', function(event) {
      const clickedLink = event.target.closest('a');
      if (!clickedLink) return;

      gtag('event', 'click', {
        event_category: 'Sub Footer Menu',
        event_label: clickedLink.textContent.trim() || 'No Link Text',
        link_url: clickedLink.href
      });
    });
  });
});


// Top Header Secondary Links
document.addEventListener('DOMContentLoaded', function() {
  if (typeof gtag !== 'function') return;

  // The "Company Info" dropdown list is rendered at the end of <body>, outside #top-panel-header
  const containers = document.querySelectorAll('#top-panel-header, .top-header-panel-links-info-menu');
  if (containers.length === 0) return;

  const dropdownTitle = document.querySelector('.top-header-panel-links-info > span')?.textContent.trim() || 'Company Info';

  containers.forEach(container => {
    container.addEventListener('click', function(event) {
      const clickedLink = event.target.closest('a');
      if (!clickedLink) return;

      const linkText = clickedLink.textContent.trim() || 'No Link Text';

      // Social links are icon-only, so label them by title. Some put the title on the inner <i>
      const eventLabel = clickedLink.closest('ul.social-links')
        ? clickedLink.title.trim() || clickedLink.querySelector('[title]')?.title.trim() || clickedLink.className.trim() || 'No Title'
        : clickedLink.closest('.top-header-panel-links-info-menu') ? `${dropdownTitle} > ${linkText}`
        : linkText;

      gtag('event', 'click', {
        event_category: 'Top Header Secondary Links',
        event_label: eventLabel,
        link_url: clickedLink.href
      });
    });
  });
});



// Product Grid Sliders - Homepage & Product Page
document.addEventListener('DOMContentLoaded', function() {
  if (typeof gtag !== 'function') return;

  const productGrids = document.querySelectorAll(
    'section.cc-featured-collection, section.cc-product-recommendations, section.cc-recently-viewed'
  );
  if (productGrids.length === 0) return;

  productGrids.forEach(section => {
    const sliderType = section.classList.contains('cc-featured-collection') ? 'Featured Collection'
      : section.classList.contains('cc-product-recommendations') ? 'You May Also Like'
      : section.classList.contains('cc-recently-viewed') ? 'Recently Viewed'
      : '';
    const eventCategory = sliderType ? `Product Grid Slider - ${sliderType}` : 'Product Grid Slider';

    section.addEventListener('click', function(event) {
      const clickedAnchor = event.target.closest('a.js-prod-link');
      if (!clickedAnchor) return;

      // Look for the h2 value *at the time of the click*
      const h2Element = this.querySelector('h2.section__heading') || this.querySelector('h2, .section__heading');
      const h2Value = h2Element?.textContent.trim() || 'Unknown Section';

      const anchorValue = clickedAnchor.title.trim()
        || clickedAnchor.getAttribute('aria-label')?.trim()
        || clickedAnchor.textContent.trim()
        || 'Unknown Product';

      // Read at click time: Recently Viewed and You May Also Like render their cards after load
      const cards = Array.from(this.querySelectorAll('product-card'));
      const cardIndex = cards.indexOf(clickedAnchor.closest('product-card'));
      const position = cardIndex >= 0 ? ` | Position: ${cardIndex + 1} of ${cards.length}` : '';

      // Skip the heading when it only repeats the slider type (e.g. "Recently Viewed - Recently Viewed")
      const isDuplicateHeading = h2Value.toLowerCase() === sliderType.toLowerCase();

      gtag('event', 'click', {
        event_category: isDuplicateHeading ? eventCategory : `${eventCategory} - ${h2Value}`,
        event_label: `${anchorValue}${position}`,
        link_url: clickedAnchor.href
      });
    });
  });
});


// Collection List Sliders (e.g. Shop Brands)
document.addEventListener('DOMContentLoaded', function() {
  if (typeof gtag !== 'function') return;
  if (!document.documentElement.classList.contains('is-home')) return;

  const carousels = document.querySelectorAll('carousel-slider');
  if (carousels.length === 0) return;

  carousels.forEach(carousel => {
    // Only track carousels that contain collection cards
    if (!carousel.querySelector('.card__collection')) return;

    carousel.addEventListener('click', function(event) {
      const clickedLink = event.target.closest('.card__collection a');
      if (!clickedLink) return;

      const section = this.closest('.section') || this.parentElement;
      const h2Value = section?.querySelector('.section__header h2, h2')?.textContent.trim() || 'Unknown Section';

      const titleText = clickedLink.closest('.card__collection').querySelector('.card__title')?.textContent.trim();
      const ariaLabel = clickedLink.getAttribute('aria-label')?.trim();
      const itemValue = titleText || ariaLabel || 'Unknown Item';

      const items = Array.from(this.querySelectorAll('.slider__item'));
      const itemIndex = items.indexOf(clickedLink.closest('.slider__item'));
      const position = itemIndex >= 0 ? ` | Position ${itemIndex + 1} of ${items.length}` : '';

      gtag('event', 'click', {
        event_category: `Collection List Slider - ${h2Value}`,
        event_label: `${itemValue}${position}`,
        link_url: clickedLink.href
      });
    });
  });
});


// Multi Column Cards (e.g. More Ways To Spruce Up Your Space)
document.addEventListener('DOMContentLoaded', function() {
  if (typeof gtag !== 'function') return;
  if (!document.documentElement.classList.contains('is-home')) return;

  const sections = document.querySelectorAll('.shopify-section.cc-multi-column');
  if (sections.length === 0) return;

  sections.forEach(section => {
    section.addEventListener('click', function(event) {
      const clickedLink = event.target.closest('li.multi-column a');
      if (!clickedLink) return;

      const h2Value = this.querySelector('h2.section__heading')?.textContent.trim() || 'Unknown Section';

      const card = clickedLink.closest('li.multi-column');
      const titleText = card.querySelector('.card__title')?.textContent.trim() || 'Unknown Card';

      // Each card has an image link, a title/text link, and a button
      const linkType = clickedLink.classList.contains('card__button') ? `Button: ${clickedLink.textContent.trim()}`
        : clickedLink.closest('.card__media') ? 'Image'
        : 'Text';

      const cards = Array.from(this.querySelectorAll('li.multi-column'));
      const position = `Position ${cards.indexOf(card) + 1} of ${cards.length}`;

      gtag('event', 'click', {
        event_category: 'Multi Column Cards',
        event_label: `${h2Value} > ${titleText} | ${linkType} | ${position}`,
        link_url: clickedLink.href
      });
    });
  });
});


// Homepage Image Banners (e.g. Faux Leather)
document.addEventListener('DOMContentLoaded', function() {
  if (typeof gtag !== 'function') return;
  if (!document.documentElement.classList.contains('is-home')) return;

  const banners = document.querySelectorAll('.image-banner');
  if (banners.length === 0) return;

  banners.forEach(banner => {
    banner.addEventListener('click', function(event) {
      const clickedLink = event.target.closest('a');
      if (!clickedLink) return;

      // Image-only banners have no link text, so fall back to the image's alt/title, then its
      // file name (e.g. ".../shop-shade-fabrics-2.jpg?v=1" -> "shop-shade-fabrics-2")
      const img = this.querySelector('.image-banner__image img');
      const fileName = (img?.currentSrc || img?.src || '').split('?')[0].split('/').pop().replace(/\.\w+$/, '');
      const bannerTitle = img?.alt.trim() || img?.title.trim() || (fileName && `No Alt/Title | Image: ${fileName}`) || 'No Alt/Title | Unknown Banner';

      // innerText, not textContent: the <noscript> fallback <img> markup counts as text inside the link
      const linkText = clickedLink.innerText.trim();

      gtag('event', 'click', {
        event_category: 'Homepage Image Banner',
        event_label: linkText && linkText !== bannerTitle ? `${bannerTitle} > ${linkText}` : bannerTitle,
        link_url: clickedLink.href
      });
    });
  });
});


// Product Page Sample Button
document.addEventListener('DOMContentLoaded', function() {
  if (typeof gtag !== 'function') return;
  if (!document.documentElement.classList.contains('is-products')) return;

  // Delegated so the button is still tracked if the theme re-renders it on variant change
  document.addEventListener('click', function(event) {
    const sampleButton = event.target.closest('button.button-sample');
    if (!sampleButton) return;

    const productTitle = (document.querySelector('h1.product-title') || document.querySelector('h1'))?.textContent.trim() || 'Unknown Product';

    // Read at click time: the SKU changes with the selected variant
    const sku = document.querySelector('.product-sku__value')?.textContent.trim();

    gtag('event', 'click', {
      event_category: 'Sample Button Clicked',
      event_label: `Sample: ${productTitle}${sku ? ` | SKU: ${sku}` : ''}`,
      link_url: window.location.href
    });
  });
});


// Product Page Fabric Builder Buttons (e.g. Build a Cushion)
document.addEventListener('DOMContentLoaded', function() {
  if (typeof gtag !== 'function') return;
  if (!document.documentElement.classList.contains('is-products')) return;

  // Delegated so the buttons are still tracked if the theme moves or re-renders the box
  document.addEventListener('click', function(event) {
    const builderLink = event.target.closest('[data-fabric-builder-links] a.builder-link');
    if (!builderLink) return;

    const productTitle = builderLink.closest('[data-fabric-builder-links]').dataset.productTitle?.trim()
      || (document.querySelector('h1.product-title') || document.querySelector('h1'))?.textContent.trim()
      || 'Unknown Product';

    const buttonText = builderLink.textContent.trim() || builderLink.dataset.builderButton || 'Unknown Builder';

    // e.g. "Sunbrella Canvas White 57003-0000  (SKU: 31774)" -> "31774"
    const sku = builderLink.dataset.fabricNameSku?.match(/SKU:\s*([^)]+)/)?.[1].trim();

    gtag('event', 'click', {
      event_category: 'Fabric Builder Button Clicked',
      event_label: `${buttonText}: ${productTitle}${sku ? ` | SKU: ${sku}` : ''}`,
      link_url: builderLink.href
    });
  });
});


// Product Card CTA Buttons (e.g. + Cart, View Details, Call To Order)
// Collection & search results grids, plus Product Grid Sliders on any page
document.addEventListener('DOMContentLoaded', function() {
  if (typeof gtag !== 'function') return;

  const htmlClasses = document.documentElement.classList;
  const isCollection = htmlClasses.contains('is-collections');
  const isSearch = htmlClasses.contains('search');

  // Same sliders as Product Grid Sliders. Cards anywhere else (e.g. quick view) are ignored
  const sliderTypes = {
    'cc-featured-collection': 'Featured Collection',
    'cc-product-recommendations': 'You May Also Like',
    'cc-recently-viewed': 'Recently Viewed'
  };
  const sliderSelector = Object.keys(sliderTypes).map(className => `section.${className}`).join(', ');

  // Delegated so cards swapped in by filtering, sorting or pagination, and slider cards that render
  // after load, are tracked. Capture phase so the click is seen before the theme's quick-add handler
  // can stop it or re-render the button
  document.addEventListener('click', function(event) {
    const button = event.target.closest('product-card .card__quick-add a, product-card .card__quick-add button');
    if (!button) return;

    const card = button.closest('product-card');
    const grid = isCollection || isSearch ? card.closest('.cc-collection-products, .main-products-grid') : null;
    const slider = grid ? null : card.closest(sliderSelector);
    const container = grid || slider;
    if (!container) return;

    let eventCategory;
    if (grid) {
      eventCategory = isCollection
        ? `Collection Product Card CTA Button - ${document.querySelector('h1')?.textContent.trim() || 'Unknown Collection'}`
        : 'Search Product Card CTA Button';
    } else {
      const sliderType = sliderTypes[Object.keys(sliderTypes).find(className => slider.classList.contains(className))];
      const h2Value = (slider.querySelector('h2.section__heading') || slider.querySelector('h2, .section__heading'))?.textContent.trim() || 'Unknown Section';
      // Skip the heading when it only repeats the slider type (e.g. "Recently Viewed - Recently Viewed")
      eventCategory = h2Value.toLowerCase() === sliderType.toLowerCase()
        ? `Product Grid Slider CTA Button - ${sliderType}`
        : `Product Grid Slider CTA Button - ${sliderType} - ${h2Value}`;
    }

    // The + Cart button repeats its text in a visually-hidden span, so prefer the visible label
    const buttonText = button.querySelector('.quick-add-btn-text')?.textContent.trim()
      || button.textContent.trim()
      || button.title.trim()
      || 'Unknown Button';

    const productLink = card.querySelector('.card-link');
    const productTitle = productLink?.textContent.trim() || productLink?.title.trim() || 'Unknown Product';

    // Read at click time: filtering and pagination replace the grid's cards
    const cards = Array.from(container.querySelectorAll('product-card'));
    const position = ` | Position: ${cards.indexOf(card) + 1} of ${cards.length}`;

    gtag('event', 'click', {
      event_category: eventCategory,
      event_label: `${buttonText}: ${productTitle}${position}`,
      link_url: button.href || productLink?.href || window.location.href
    });
  }, true);
});



// List Click Count
document.addEventListener('DOMContentLoaded', function() {
  if (typeof gtag !== 'function') return;
  // Skip search results: the Shopify Google app sends no view_item_list there, so clicks would show 0 views
  // Regex allows locale/market prefixes (e.g. /en-ca/search)
  if (/\/search\/?$/.test(window.location.pathname)) return;

  // Only the main collection grid. Carousels (e.g. homepage "Shop Newest Arrivals") also use <product-card>,
  // but they're tracked by Product Grid Sliders and the app sends no view_item_list for them. Scoping here
  // also keeps index aligned with the grid instead of offset by carousel cards earlier in the page
  const productCards = document.querySelectorAll('.cc-collection-products product-card');
  if (productCards.length === 0) return;

  // 1. Dynamic List Name Parser (Matches the App's H1 Extraction)
  const parsedListName = document.querySelector('h1')?.textContent.trim() || 'Collection Products';

  productCards.forEach(function(card, index) {
    // 2. Early Return: Enforce the native Shopify app 20-item tracking cap
    if (index > 19) return;

    const productLinks = card.querySelectorAll('.js-prod-link');
    if (productLinks.length === 0) return;

    productLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        // 3. Safe Field Validations & Early Returns (read at click time so the selected variant is current)
        const variantId = card.querySelector('product-form input[name="id"]')?.value;
        if (!variantId) return;

        const productId = card.querySelector('input[name="product-id"]')?.value;
        if (!productId) return;

        const itemName = card.querySelector('.card-link')?.textContent.trim();
        if (!itemName) return;

        // 4. Price Sanitization & Float Conversion. Strip everything but digits and the decimal
        // point so market prefixes like "CA$" don't turn the price into NaN
        const cleanPriceStr = card.querySelector('.price__current')?.textContent.replace(/[^\d.]/g, '') || '';
        let itemPrice = parseFloat(cleanPriceStr) || 0;
        if (itemPrice > 0 && !cleanPriceStr.includes('.')) {
          itemPrice = itemPrice / 100;
        }

        // 5. Fire the event containing ONLY matched parameters
        // Notice that item_list_id is completely omitted so GA4 defaults it to (not set), matching the app.
        gtag('event', 'select_item', {
          item_list_name: parsedListName,
          items: [{
            item_id: `shopify_ZZ_${productId}_${variantId}`,
            item_name: itemName,
            price: itemPrice,
            index
          }]
        });
      });
    });
  });
});


// GA4 bot/spam flagging. Adds traffic_type=bot_spam to all later GA4 events.
// Needs a GA4 data filter (Internal traffic, value "bot_spam") to exclude them.
(function () {
  if (typeof gtag !== 'function') return;

  var KEY = 'ga_bot_check';
  var flagged = false;

  function flag(reason) {
    if (flagged) return;
    flagged = true;
    try { sessionStorage.setItem(KEY, 'bot:' + reason); } catch (e) {}
    gtag('set', { traffic_type: 'bot_spam' });
    gtag('set', 'user_properties', { traffic_type: 'bot_spam' }); // optional, for segments
  }

  // Already checked this session: flag right away (before page_view) or skip BotD
  var prior = null;
  try { prior = sessionStorage.getItem(KEY); } catch (e) {}
  if (prior && prior.indexOf('bot:') === 0) return flag(prior.slice(4));

  // Cheap sync checks
  if (navigator.webdriver) return flag('webdriver');
  if (/HeadlessChrome|PhantomJS|Lighthouse/i.test(navigator.userAgent)) return flag('ua');

  var res = screen.width + 'x' + screen.height;
  var spamRes = ['1600x1600', '1366x1366', '1280x1200', '1024x1024', '2000x2000'];
  var refHost = '';
  try { refHost = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
  if ((!refHost || refHost === location.hostname) && spamRes.indexOf(res) !== -1) {
    return flag('resolution');
  }

  if (prior === 'clean') return; // BotD already passed this session

  // BotD (async: only affects events after it resolves)
  import('https://openfpcdn.io/botd/v2')
    .then(function (B) { return B.load(); })
    .then(function (b) { return b.detect(); })
    .then(function (r) {
      if (r && r.bot) flag('botd');
      else try { sessionStorage.setItem(KEY, 'clean'); } catch (e) {}
    })
    .catch(function () {});
})();
